/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Low_Vole_FlopInputs */

const fr_misty_low_vole_flop = /** @type {(inputs: Misty_Low_Vole_FlopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement...`)
};

/**

* @param {Misty_Low_Vole_FlopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const misty_low_vole_flop = /** @type {((inputs?: Misty_Low_Vole_FlopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Low_Vole_FlopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_misty_low_vole_flop(inputs)
});